module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "StatsDisplay"
    }
  }, [_c('h4', [_vm._v(" Stats Display ")]), _vm._v(" "), _c('pre', [_vm._v(_vm._s(_vm.sortedStats))]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "buffered_log"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.log)
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-088dad84!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Debug/DebugStats.vue
// module id = 86
// module chunks = 0